export enum AuftraggeberRoutes {
  // Aufgaben
  AG_AUFGABEN_LISTE = 'aufgabenListeAuftraggeber',
  // Bürgschaft Detailansicht
  AG_BUERGSCHAFT_DETAIL = 'buergschaftDetailsAuftraggeber',

  // Enthaftung angefordert
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE = 'auftraggeber-rueckforderung-pruefen-aufgabe-base',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_PRUEFEN = 'auftraggeber-rueckforderung-pruefen-aufgabe-pruefen',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_ENTSCHEIDUNG = 'auftraggeber-rueckforderung-pruefen-aufgabe-entscheidung',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_BESTAETIGEN = 'auftraggeber-rueckforderung-pruefen-aufgabe-bestaetigen',
  AG_BUERGSCHAFT_ABGETRETEN_DETAIL = 'buergschaftAbgetretenDetailsAuftraggeber',
  // Abgetretene Bürgschaft Detailansicht
  // Bürgschaft-Abtreten
  AG_BUERGSCHAFT_ABTRETEN = 'auftraggeber-buergschaft-abtreten-base',
  AG_BUERGSCHAFT_ABTRETEN_EMPFAENGER = 'auftraggeber-buergschaft-abtreten-empfaenger',
  AG_BUERGSCHAFT_ABTRETEN_ANSPRECHPARTNER = 'auftraggeber-buergschaft-abtreten-ansprechpartner',
  AG_BUERGSCHAFT_ABTRETEN_PRUEFEN = 'auftraggeber-buergschaft-abtreten-pruefen',
  AG_BUERGSCHAFT_ABTRETEN_BESTAETIGEN = 'auftraggeber-buergschaft-abtreten-bestaetigen',
  // Abtretung prüfen
  AG_ABTRETUNG_PRUEFEN_AUFGABE = 'auftraggeber-abtretung-pruefen-aufgabe-base',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_PRUEFEN = 'auftraggeber-abtretung-pruefen-aufgabe-pruefen',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_ENTSCHEIDUNG = 'auftraggeber-abtretung-pruefen-aufgabe-entscheidung',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_BESTAETIGEN = 'auftraggeber-abtretung-pruefen-aufgabe-bestaetigen',
  // Projekt Details Bearbeiten
  AG_PROJEKT_FORM_BEARBEITEN = 'auftraggeber-projekt-bearbeiten-base',
  AG_PROJEKT_FORM_ANLEGEN = 'auftraggeber-projekt-anlegen-base',
  AG_PROJEKT_FORM_DETAILS = 'auftraggeber-projekt-form-details',
  AG_PROJEKT_FORM_VERANTWORTLICHES_UNTERNEHMEN = 'auftraggeber-projekt-form-verantwortliches-unternehmen',
  AG_PROJEKT_FORM_SICHTBERECHTIGUNG = 'auftraggeber-projekt-form-sichtberechtigung',
}
